/* eslint-disable */
// tslint:disable
/**
 * Кабинет муниципалитета
 * todo
 *
 * OpenAPI spec version: 1.6.0
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator+.
 * https://github.com/karlvr/openapi-generator-plus
 * Do not edit the class manually.
 */

export namespace Api {
	export interface ActivityStatistics {
		total: Api.ActivityStatistics.Total;
		detailed_data: Api.ActivityStatistics.DetailedDatum[];
	}
	
	/**
	 * @export
	 * @namespace ActivityStatistics
	 */
	export namespace ActivityStatistics {
		export interface Total extends Api.PeopleCounts {
			/**
			 * <p>только для регионов</p>
			 * @type {number}
			 * @memberof Total
			 */
			school_count?: number;
		}
	
		export interface DetailedDatum extends Api.PeopleCounts {
			/**
			 * <p>только для муниципалитетов</p>
			 * @type {number}
			 * @memberof DetailedDatum
			 */
			school_id?: number;
			/**
			 * <p>только для муниципалитетов</p>
			 * @type {string}
			 * @memberof DetailedDatum
			 */
			school_location?: string;
			/**
			 * <p>только для муниципалитетов</p>
			 * @type {string}
			 * @memberof DetailedDatum
			 */
			school_name?: string;
			/**
			 * <p>только для регионов</p>
			 * @type {string}
			 * @memberof DetailedDatum
			 */
			municipality_name?: string;
			/**
			 * <p>только для регионов</p>
			 * @type {number}
			 * @memberof DetailedDatum
			 */
			school_count?: number;
			/**
			 * <p>только для регионов</p>
			 * @type {number | null}
			 * @memberof DetailedDatum
			 */
			involvement_percent?: number | null;
		}
	
	}

	export interface ActivityStatisticsBySchoolSubjects {
		total: Api.ActivityStatisticsBySchoolSubjects.Total[];
		detailed_data: Api.ActivityStatisticsBySchoolSubjects.DetailedDatum[];
	}
	
	/**
	 * @export
	 * @namespace ActivityStatisticsBySchoolSubjects
	 */
	export namespace ActivityStatisticsBySchoolSubjects {
		export interface Total {
			/**
			 * <p>interactive or automatic</p>
			 * @type {string}
			 * @memberof Total
			 */
			task_type: string;
			/**
			 * <p>Название предмета</p>
			 * @type {string}
			 * @memberof Total
			 */
			school_subject: string;
			/**
			 * <p>primary or middle of high</p>
			 * @type {string}
			 * @memberof Total
			 */
			group: string;
			/**
			 * @type {number}
			 * @memberof Total
			 */
			students_count: number;
		}
	
		export interface DetailedDatum extends Api.ActivityStatisticsBySchoolSubjects.Total {
			/**
			 * @type {number | null}
			 * @memberof DetailedDatum
			 */
			municipality_id?: number | null;
			/**
			 * @type {number | null}
			 * @memberof DetailedDatum
			 */
			school_id?: number | null;
		}
	
	}

	export interface ApiV1PretendsPost404 {
		/**
		 * <p>User not logged</p>
		 * @type {string}
		 * @memberof ApiV1PretendsPost404
		 */
		description: string;
	}

	export interface CheckAuth200Response {
		created_at: string;
		department: string;
		digital_school_started_at: string;
		display_name: string;
		/**
		 * @type {number}
		 * @memberof CheckAuth200Response
		 */
		id: number;
		is_pretended: boolean;
		large_city: boolean;
		login: string;
		middlename: string | null;
		municipality_fias: string | null;
		name: string | null;
		/**
		 * @type {number}
		 * @memberof CheckAuth200Response
		 */
		region: number;
		region_name: string;
		small_name: string | null;
		surname: string | null;
		type: string;
		updated_at: string;
		user_type: string;
		uchiru_info_contacts: Api.CheckAuth200Response.UchiruInfoContacts;
		gr_manager: Api.CheckAuth200Response.GrManager;
		ab_test_mark?: string | null;
		fias_aoguids: string[];
	}
	
	/**
	 * @export
	 * @namespace CheckAuth200Response
	 */
	export namespace CheckAuth200Response {
		export interface UchiruInfoContacts {
			email?: string;
			phone?: string;
		}
	
		export interface GrManager {
			email?: string;
			full_name?: string;
			phone?: string;
		}
	
	}

	export interface CheckAuth404Response {
		/**
		 * <p>User not logged</p>
		 * @type {string}
		 * @memberof CheckAuth404Response
		 */
		description: string;
	}

	export interface GetDefaultParamsData200Response {
		data: Api.GetDefaultParamsData200Response.Data;
	}
	
	/**
	 * @export
	 * @namespace GetDefaultParamsData200Response
	 */
	export namespace GetDefaultParamsData200Response {
		export interface Data {
			student_subjects_levels: Api.GetDefaultParamsData200Response.Data.StudentSubjectsLevels;
			students_students_teachers_distribution: Api.GetDefaultParamsData200Response.Data.StudentsStudentsTeachersDistribution;
		}
		
		/**
		 * @export
		 * @namespace Data
		 */
		export namespace Data {
			export interface StudentSubjectsLevels {
				parallels: number[];
				subjects: string[];
			}
		
			export interface StudentsStudentsTeachersDistribution {
				rtr: string;
			}
		
		}
	
	}

	export interface GetDefaultParamsData404Response {
		/**
		 * <p>Сообщение об ошибке</p>
		 * @type {string}
		 * @memberof GetDefaultParamsData404Response
		 */
		description: string;
	}

	export interface GetDigitalSchoolXlsx404Response {
		/**
		 * <p>Сообщение об ошибке</p>
		 * @type {string}
		 * @memberof GetDigitalSchoolXlsx404Response
		 */
		description: string;
	}

	export interface GetDownloadLink404Response {
		/**
		 * <p>Сообщение об ошибке</p>
		 * @type {string}
		 * @memberof GetDownloadLink404Response
		 */
		description: string;
	}

	export interface GetInformation200Response {
		/**
		 * <p>Активность класса</p>
		 * @type {Api.GetInformation200Response.Activity[]}
		 * @memberof GetInformation200Response
		 */
		activities?: Api.GetInformation200Response.Activity[];
		/**
		 * <p>название класса</p>
		 * @type {string}
		 * @memberof GetInformation200Response
		 */
		group_name?: string;
		/**
		 * <p>Название муниципалитета</p>
		 * @type {string}
		 * @memberof GetInformation200Response
		 */
		municipality_display_name?: string;
		/**
		 * <p>Идентификатор муниципалитета</p>
		 * @type {number}
		 * @memberof GetInformation200Response
		 */
		municipality_id?: number;
		/**
		 * <p>Номер класса</p>
		 * @type {number}
		 * @memberof GetInformation200Response
		 */
		parallel?: number;
		/**
		 * <p>Динамика проведения уроков</p>
		 * @type {string}
		 * @memberof GetInformation200Response
		 */
		regularity?: string;
		/**
		 * <p>Полное название школы</p>
		 * @type {string}
		 * @memberof GetInformation200Response
		 */
		school_title?: string;
		/**
		 * <p>ФИО Учителя</p>
		 * @type {string}
		 * @memberof GetInformation200Response
		 */
		teacher_name?: string;
	}
	
	/**
	 * @export
	 * @namespace GetInformation200Response
	 */
	export namespace GetInformation200Response {
		export interface Activity {
			/**
			 * <p>День активности</p>
			 * @type {string}
			 * @memberof Activity
			 */
			date?: string;
			/**
			 * <p>Была ли активность</p>
			 * @type {boolean}
			 * @memberof Activity
			 */
			active?: boolean;
		}
	
	}

	export interface GetInformation404Response {
		/**
		 * <p>Сообщение об ошибке</p>
		 * @type {string}
		 * @memberof GetInformation404Response
		 */
		description: string;
	}

	export interface GetIntroduceInformation200Response {
		intro_data?: Api.GetIntroduceInformation200Response.IntroData;
	}
	
	/**
	 * @export
	 * @namespace GetIntroduceInformation200Response
	 */
	export namespace GetIntroduceInformation200Response {
		export interface IntroData {
			groups_amount_by_parallels?: Api.GetIntroduceInformation200Response.IntroData.GroupsAmountByParallel[];
			/**
			 * <p>Количесво классов</p>
			 * @type {number}
			 * @memberof IntroData
			 */
			groups_count?: number;
			/**
			 * <p>Количество недавно активных групп</p>
			 * @type {number}
			 * @memberof IntroData
			 */
			recently_active_groups_count?: number;
			/**
			 * <p>Количество школ подключенных к программе</p>
			 * @type {number}
			 * @memberof IntroData
			 */
			schools_count?: number;
			started_at?: string;
		}
		
		/**
		 * @export
		 * @namespace IntroData
		 */
		export namespace IntroData {
			export interface GroupsAmountByParallel {
				/**
				 * @type {number}
				 * @memberof GroupsAmountByParallel
				 */
				count?: number;
				parallel?: string;
			}
		
		}
	
	}

	export interface GetIntroduceInformation404Response {
		/**
		 * <p>Сообщение об ошибке</p>
		 * @type {string}
		 * @memberof GetIntroduceInformation404Response
		 */
		description: string;
	}

	export interface GetIntroductionForActualService200Response {
		data: Api.GetIntroductionForActualService200Response.Data;
	}
	
	/**
	 * @export
	 * @namespace GetIntroductionForActualService200Response
	 */
	export namespace GetIntroductionForActualService200Response {
		export interface Data {
			/**
			 * <p>Дата подключения к программе</p>
			 * @type {string}
			 * @memberof Data
			 */
			date: string;
			/**
			 * <p>Количество студентов подключенных к программе</p>
			 * @type {number}
			 * @memberof Data
			 */
			students_count: number;
			/**
			 * <p>Количество учителей подключенных к программе</p>
			 * @type {number}
			 * @memberof Data
			 */
			teachers_count: number;
		}
	
	}

	export interface GetIntroductionForActualService404Response {
		/**
		 * <p>Сообщение об ошибке</p>
		 * @type {string}
		 * @memberof GetIntroductionForActualService404Response
		 */
		description: string;
	}

	export interface GetListOfMunicipalitets200Response {
		/**
		 * @type {number}
		 * @memberof GetListOfMunicipalitets200Response
		 */
		id: number;
		display_name: string;
		department: string;
		small_name: string | null;
	}

	export interface GetListOfMunicipalitets404Response {
		/**
		 * <p>Сообщение об ошибке</p>
		 * @type {string}
		 * @memberof GetListOfMunicipalitets404Response
		 */
		description: string;
	}

	export interface GetMunicipalityRatingsByOlympiads200Response {
		olympiad_id: string;
		ratings: (Api.GetMunicipalityRatingsByOlympiads200Response.Rating[]) | null;
	}
	
	/**
	 * @export
	 * @namespace GetMunicipalityRatingsByOlympiads200Response
	 */
	export namespace GetMunicipalityRatingsByOlympiads200Response {
		export interface Rating {
			/**
			 * @type {number}
			 * @memberof Rating
			 */
			subject_id: number;
			subject_name: string;
			/**
			 * @type {number}
			 * @memberof Rating
			 */
			value: number;
			/**
			 * @type {number}
			 * @memberof Rating
			 */
			participants_count: number;
			/**
			 * @type {number}
			 * @memberof Rating
			 */
			real_students_count: number;
		}
	
	}

	export interface GetMunicipalityRatingsByOlympiads404Response {
		/**
		 * <p>Сообщение об ошибке</p>
		 * @type {string}
		 * @memberof GetMunicipalityRatingsByOlympiads404Response
		 */
		description: string;
	}

	export interface GetMunicipalitySchoolsData200Response {
		data: Api.GetMunicipalitySchoolsData200Response.Datum[];
	}
	
	/**
	 * @export
	 * @namespace GetMunicipalitySchoolsData200Response
	 */
	export namespace GetMunicipalitySchoolsData200Response {
		export interface Datum {
			/**
			 * @type {number}
			 * @memberof Datum
			 */
			id: number;
			official_title: string;
		}
	
	}

	export interface GetMunicipalitySchoolsData404Response {
		/**
		 * <p>Сообщение об ошибке</p>
		 * @type {string}
		 * @memberof GetMunicipalitySchoolsData404Response
		 */
		description: string;
	}

	export interface GetOlyimpiadReportById404Response {
		/**
		 * <p>Сообщение об ошибке</p>
		 * @type {string}
		 * @memberof GetOlyimpiadReportById404Response
		 */
		description: string;
	}

	export interface GetOlyimpiadsList200Response {
		olympiads?: Api.GetOlyimpiadsList200Response.Olympiad[];
	}
	
	/**
	 * @export
	 * @namespace GetOlyimpiadsList200Response
	 */
	export namespace GetOlyimpiadsList200Response {
		export interface Olympiad {
			olympiad_id?: string;
			olympiad_start?: string;
			icon: string | null;
			rating?: Api.GetOlyimpiadsList200Response.Olympiad.Rating | null;
			attachments: Api.GetOlyimpiadsList200Response.Olympiad.Attachment[];
			name: string;
			url?: string;
			dates: string;
			description?: string | null;
			total?: Api.GetOlyimpiadsList200Response.Olympiad.Total | null;
			schools?: (Api.GetOlyimpiadsList200Response.Olympiad.School[]) | null;
			cards?: Api.GetOlyimpiadsList200Response.Olympiad.Card[];
			/**
			 * @type {number}
			 * @memberof Olympiad
			 */
			registered?: number;
			/**
			 * @type {number}
			 * @memberof Olympiad
			 */
			registered_cumulative?: number;
			start_interval?: string;
		}
		
		/**
		 * @export
		 * @namespace Olympiad
		 */
		export namespace Olympiad {
			export interface Rating {
				improve_button_link?: string;
				popup_text?: string;
			}
		
			export interface Attachment {
				title: string;
				link: string;
				type: string;
			}
		
			export interface Total {
				/**
				 * @type {number}
				 * @memberof Total
				 */
				active_students_count: number;
				/**
				 * @type {number}
				 * @memberof Total
				 */
				participants_percent: number;
				/**
				 * @type {number}
				 * @memberof Total
				 */
				participants_count: number;
				/**
				 * @type {number}
				 * @memberof Total
				 */
				prizeholders_percent?: number;
				/**
				 * @type {number}
				 * @memberof Total
				 */
				prizeholders_count?: number;
				/**
				 * @type {number | null}
				 * @memberof Total
				 */
				real_students_count?: number | null;
			}
		
			export interface School {
				municipalicy: string;
				school_title: string;
				/**
				 * @type {number}
				 * @memberof School
				 */
				active_students_count: number;
				/**
				 * @type {number}
				 * @memberof School
				 */
				participants_percent: number;
				/**
				 * @type {number}
				 * @memberof School
				 */
				participants_count: number;
				/**
				 * @type {number}
				 * @memberof School
				 */
				prizeholders_percent?: number;
				/**
				 * @type {number}
				 * @memberof School
				 */
				prizeholders_count?: number;
			}
		
			export interface Card {
				difficulty: string;
				name: string;
				description: string;
				/**
				 * @type {number}
				 * @memberof Card
				 */
				correct_answers_percent: number;
				/**
				 * @type {number}
				 * @memberof Card
				 */
				correct_answers_percent_russia: number;
			}
		
		}
	
	}

	export interface GetOlyimpiadsList404Response {
		/**
		 * <p>Сообщение об ошибке</p>
		 * @type {string}
		 * @memberof GetOlyimpiadsList404Response
		 */
		description: string;
	}

	export interface GetOlyimpiadsListForRegion200Response {
		olympiads?: Api.GetOlyimpiadsListForRegion200Response.Olympiad[];
	}
	
	/**
	 * @export
	 * @namespace GetOlyimpiadsListForRegion200Response
	 */
	export namespace GetOlyimpiadsListForRegion200Response {
		export interface Olympiad {
			olympiad_id?: string;
			olympiad_start?: string;
			icon: string;
			attachments: Api.GetOlyimpiadsListForRegion200Response.Olympiad.Attachment[];
			name: string;
			url?: string;
			dates: string;
			description?: string | null;
			rating?: Api.GetOlyimpiadsListForRegion200Response.Olympiad.Rating | null;
			total?: Api.GetOlyimpiadsListForRegion200Response.Olympiad.Total;
			municipalities?: Api.GetOlyimpiadsListForRegion200Response.Olympiad.Municipality[];
			cards?: Api.GetOlyimpiadsListForRegion200Response.Olympiad.Card[];
			/**
			 * @type {number}
			 * @memberof Olympiad
			 */
			registered?: number;
			/**
			 * @type {number}
			 * @memberof Olympiad
			 */
			registered_cumulative?: number;
			start_interval?: string;
		}
		
		/**
		 * @export
		 * @namespace Olympiad
		 */
		export namespace Olympiad {
			export interface Attachment {
				title: string;
				link: string;
				type: string;
			}
		
			export interface Rating {
				improve_button_link?: string;
				popup_text?: string;
			}
		
			export interface Total {
				/**
				 * @type {number}
				 * @memberof Total
				 */
				active_students_count: number;
				/**
				 * @type {number}
				 * @memberof Total
				 */
				participants_percent: number;
				/**
				 * @type {number}
				 * @memberof Total
				 */
				participants_count: number;
				/**
				 * @type {number}
				 * @memberof Total
				 */
				prizeholders_percent?: number;
				/**
				 * @type {number}
				 * @memberof Total
				 */
				prizeholders_count?: number;
			}
		
			export interface Municipality {
				municipalicy: string;
				/**
				 * @type {number}
				 * @memberof Municipality
				 */
				active_students_count: number;
				/**
				 * @type {number}
				 * @memberof Municipality
				 */
				participants_percent: number;
				/**
				 * @type {number}
				 * @memberof Municipality
				 */
				participants_count: number;
				/**
				 * @type {number}
				 * @memberof Municipality
				 */
				prizeholders_percent?: number;
				/**
				 * @type {number}
				 * @memberof Municipality
				 */
				prizeholders_count?: number;
			}
		
			export interface Card {
				difficulty: string;
				name: string;
				description: string;
				/**
				 * @type {number}
				 * @memberof Card
				 */
				correct_answers_percent: number;
				/**
				 * @type {number}
				 * @memberof Card
				 */
				correct_answers_percent_russia: number;
			}
		
		}
	
	}

	export interface GetOlyimpiadsListForRegion404Response {
		/**
		 * <p>Сообщение об ошибке</p>
		 * @type {string}
		 * @memberof GetOlyimpiadsListForRegion404Response
		 */
		description: string;
	}

	export interface GetOlyimpiadsReportForPeriod404Response {
		/**
		 * <p>Сообщение об ошибке</p>
		 * @type {string}
		 * @memberof GetOlyimpiadsReportForPeriod404Response
		 */
		description: string;
	}

	export interface GetOlympiadsPdf404Response {
		/**
		 * <p>Сообщение об ошибке</p>
		 * @type {string}
		 * @memberof GetOlympiadsPdf404Response
		 */
		description: string;
	}

	export interface GetParallelsSubjectsData200Response {
		data?: Api.GetParallelsSubjectsData200Response.Data;
	}
	
	/**
	 * @export
	 * @namespace GetParallelsSubjectsData200Response
	 */
	export namespace GetParallelsSubjectsData200Response {
		export interface Data {
			0?: string[];
			1?: string[];
			2?: string[];
			3?: string[];
			4?: string[];
			5?: string[];
			6?: string[];
			7?: string[];
			8?: string[];
			9?: string[];
			10?: string[];
			11?: string[];
		}
	
	}

	export interface GetParallelsSubjectsData404Response {
		/**
		 * <p>Сообщение об ошибке</p>
		 * @type {string}
		 * @memberof GetParallelsSubjectsData404Response
		 */
		description: string;
	}

	export interface GetParamsXSL200Response {
		/**
		 * <p>Список муниципалитетов</p>
		 * @type {Api.GetParamsXSL200Response.Municipality[]}
		 * @memberof GetParamsXSL200Response
		 */
		municipalities?: Api.GetParamsXSL200Response.Municipality[];
		/**
		 * <p>Номера классов</p>
		 * @type {number[]}
		 * @memberof GetParamsXSL200Response
		 */
		parallels?: number[];
		/**
		 * <p>Список школ</p>
		 * @type {string[]}
		 * @memberof GetParamsXSL200Response
		 */
		schools?: string[];
	}
	
	/**
	 * @export
	 * @namespace GetParamsXSL200Response
	 */
	export namespace GetParamsXSL200Response {
		export interface Municipality {
			/**
			 * <p>Идентификатор муниципалитета</p>
			 * @type {number}
			 * @memberof Municipality
			 */
			id?: number;
			/**
			 * <p>Название муниципалитета</p>
			 * @type {string}
			 * @memberof Municipality
			 */
			display_name?: string;
		}
	
	}

	export interface GetParamsXSL404Response {
		/**
		 * <p>Сообщение об ошибке</p>
		 * @type {string}
		 * @memberof GetParamsXSL404Response
		 */
		description: string;
	}

	export interface GetParticipantsReportXlsx404Response {
		/**
		 * <p>Сообщение об ошибке</p>
		 * @type {string}
		 * @memberof GetParticipantsReportXlsx404Response
		 */
		description: string;
	}

	export interface GetProgressesReportXlsx404Response {
		/**
		 * <p>Сообщение об ошибке</p>
		 * @type {string}
		 * @memberof GetProgressesReportXlsx404Response
		 */
		description: string;
	}

	export interface GetRatingOlympiad200Response {
		olymp_id: string;
		participants_count: string;
		participants_percent: string;
		active_students_count: string;
	}

	export interface GetRatingSafenet200Response {
		olymp_id: string;
		participants_count: string;
		participants_percent: string;
	}

	export interface GetResultOlympiads200Response {
		olymp_id: string;
		participants_count: string;
		participants_percent: string;
		active_students_count: string;
		prizeholders_count: string;
		transiting_prizeholders_count: string;
		real_students_count: string;
	}

	export enum GetResultOlympiadsByGradesXlsxStatusEnum {
		_1 = '1',
		_2 = '2'
	}

	export enum GetResultOlympiadsXlsxStatusEnum {
		_1 = '1',
		_2 = '2'
	}

	export interface GetSchoolTotals200Response {
		/**
		 * @type {number}
		 * @memberof GetSchoolTotals200Response
		 */
		schools_count: number;
		/**
		 * @type {number}
		 * @memberof GetSchoolTotals200Response
		 */
		active_teachers_count: number;
		/**
		 * @type {number}
		 * @memberof GetSchoolTotals200Response
		 */
		reg_teachers_count: number;
	}

	export interface GetTestParticipantsForMunicipality404Response {
		/**
		 * <p>Сообщение об ошибке</p>
		 * @type {string}
		 * @memberof GetTestParticipantsForMunicipality404Response
		 */
		description: string;
	}

	export interface GetTestParticipantsForRegion404Response {
		/**
		 * <p>Сообщение об ошибке</p>
		 * @type {string}
		 * @memberof GetTestParticipantsForRegion404Response
		 */
		description: string;
	}

	export interface GetTestProgressesForMunicipality404Response {
		/**
		 * <p>Сообщение об ошибке</p>
		 * @type {string}
		 * @memberof GetTestProgressesForMunicipality404Response
		 */
		description: string;
	}

	export interface GetTestProgressesForRegion404Response {
		/**
		 * <p>Сообщение об ошибке</p>
		 * @type {string}
		 * @memberof GetTestProgressesForRegion404Response
		 */
		description: string;
	}

	export interface GetTestsList200Response {
		subject: string;
		/**
		 * @type {number}
		 * @memberof GetTestsList200Response
		 */
		test_id: number;
		test_name: string;
		test_start: string;
		test_end: string;
	}

	export interface GetTestsList404Response {
		/**
		 * <p>Сообщение об ошибке</p>
		 * @type {string}
		 * @memberof GetTestsList404Response
		 */
		description: string;
	}

	export interface GetTotals200Response {
		/**
		 * @type {number}
		 * @memberof GetTotals200Response
		 */
		students_count?: number;
		/**
		 * @type {number}
		 * @memberof GetTotals200Response
		 */
		teachers_count?: number;
	}

	export interface GetTotalStatistic200Response {
		/**
		 * @type {number}
		 * @memberof GetTotalStatistic200Response
		 */
		planned: number;
		/**
		 * @type {number}
		 * @memberof GetTotalStatistic200Response
		 */
		completed: number;
		/**
		 * @type {number}
		 * @memberof GetTotalStatistic200Response
		 */
		remaining: number;
		/**
		 * @type {number}
		 * @memberof GetTotalStatistic200Response
		 */
		current: number;
		/**
		 * @type {number}
		 * @memberof GetTotalStatistic200Response
		 */
		active_students_count: number;
		/**
		 * @type {number}
		 * @memberof GetTotalStatistic200Response
		 */
		median_activity?: number;
		/**
		 * @type {number}
		 * @memberof GetTotalStatistic200Response
		 */
		students_per_olympiad?: number;
		/**
		 * @type {number}
		 * @memberof GetTotalStatistic200Response
		 */
		prizeholders_percent?: number;
		/**
		 * @type {number}
		 * @memberof GetTotalStatistic200Response
		 */
		prizeholders_total?: number;
	}

	export interface GetTotalStatistic404Response {
		/**
		 * <p>Сообщение об ошибке</p>
		 * @type {string}
		 * @memberof GetTotalStatistic404Response
		 */
		description: string;
	}

	export interface GetUnAuthOlympiads200Response {
		icon: string;
		attachments: Api.GetUnAuthOlympiads200Response.Attachment[];
		name: string;
		url?: string;
		dates: string;
		description?: string | null;
		status?: string;
		olympiad_id?: string;
		olympiad_start?: string;
		olympiad_end?: string;
		hint?: string | null;
		popup_text?: string | null;
	}
	
	/**
	 * @export
	 * @namespace GetUnAuthOlympiads200Response
	 */
	export namespace GetUnAuthOlympiads200Response {
		export interface Attachment {
			title: string;
			link: string;
			type: string;
		}
	
	}

	export interface Login200Response {
		massage?: string;
	}

	export interface Login401Response {
		/**
		 * <p>User not logged</p>
		 * @type {string}
		 * @memberof Login401Response
		 */
		description: string;
	}

	export interface LoginRequest {
		data: Api.LoginRequest.Data;
	}
	
	/**
	 * @export
	 * @namespace LoginRequest
	 */
	export namespace LoginRequest {
		export interface Data {
			login: string;
			password: string;
			user_type: string;
		}
	
	}

	export interface Logout200Response {
		massage?: string;
	}

	export interface PeopleCounts {
		/**
		 * @type {number}
		 * @memberof PeopleCounts
		 */
		reg_student_count: number;
		/**
		 * @type {number}
		 * @memberof PeopleCounts
		 */
		active_student_count: number;
		/**
		 * @type {number}
		 * @memberof PeopleCounts
		 */
		reg_teacher_count: number;
		/**
		 * @type {number}
		 * @memberof PeopleCounts
		 */
		active_teacher_count: number;
	}

	export interface PeopleCountsSample extends Api.PeopleCumulative, Api.PeopleCounts {
	}

	export interface PeopleCumulative {
		/**
		 * @type {number}
		 * @memberof PeopleCumulative
		 */
		reg_student_cumulative: number;
		/**
		 * @type {number}
		 * @memberof PeopleCumulative
		 */
		active_student_cumulative: number;
		/**
		 * @type {number}
		 * @memberof PeopleCumulative
		 */
		reg_teacher_cumulative: number;
		/**
		 * @type {number}
		 * @memberof PeopleCumulative
		 */
		active_teacher_cumulative: number;
	}

	export interface PretendsRequest {
		pretend?: Api.PretendsRequest.Pretend;
	}
	
	/**
	 * @export
	 * @namespace PretendsRequest
	 */
	export namespace PretendsRequest {
		export interface Pretend {
			/**
			 * @type {number}
			 * @memberof Pretend
			 */
			id?: number;
		}
	
	}

	export interface StatisticByMonth {
		total: Api.StatisticByMonth.Total[];
		detailed_data: Api.StatisticByMonth.DetailedDatum[];
	}
	
	/**
	 * @export
	 * @namespace StatisticByMonth
	 */
	export namespace StatisticByMonth {
		export interface Total extends Api.PeopleCountsSample {
			/**
			 * <p>Дата замера (первый день месяца)</p>
			 * @type {string}
			 * @memberof Total
			 */
			sample_date: string;
		}
	
		export interface DetailedDatum extends Api.PeopleCountsSample {
			/**
			 * <p>Дата замера (первый день месяца)</p>
			 * @type {string}
			 * @memberof DetailedDatum
			 */
			sample_date: string;
			/**
			 * @type {number}
			 * @memberof DetailedDatum
			 */
			school_id?: number;
			/**
			 * @type {number}
			 * @memberof DetailedDatum
			 */
			subject_id?: number;
		}
	
	}

	export interface StatisticByParallel {
		total: Api.StatisticByParallel.Total[];
		detailed_data: Api.StatisticByParallel.DetailedDatum[];
	}
	
	/**
	 * @export
	 * @namespace StatisticByParallel
	 */
	export namespace StatisticByParallel {
		export interface Total extends Api.PeopleCounts {
			parallel: string;
			/**
			 * @type {number}
			 * @memberof Total
			 */
			grade_count: number;
		}
	
		export interface DetailedDatum extends Api.PeopleCounts {
			parallel: string;
			/**
			 * @type {number}
			 * @memberof DetailedDatum
			 */
			grade_count: number;
			/**
			 * @type {number}
			 * @memberof DetailedDatum
			 */
			school_id: number;
			/**
			 * @type {number}
			 * @memberof DetailedDatum
			 */
			subject_id: number;
		}
	
	}

	export interface TestParticipantsBase {
		/**
		 * @type {number}
		 * @memberof TestParticipantsBase
		 */
		involved_teachers_count: number;
		/**
		 * @type {number}
		 * @memberof TestParticipantsBase
		 */
		parallel: number;
		/**
		 * @type {number}
		 * @memberof TestParticipantsBase
		 */
		test_id: number;
		/**
		 * @type {number}
		 * @memberof TestParticipantsBase
		 */
		tested_students_count: number;
	}

	export interface TestParticipantsForMunicipality {
		participants_data: Api.TestParticipantsForMunicipality.ParticipantsDatum[];
		total: Api.TestParticipantsBase[];
	}
	
	/**
	 * @export
	 * @namespace TestParticipantsForMunicipality
	 */
	export namespace TestParticipantsForMunicipality {
		export interface ParticipantsDatum extends Api.TestParticipantsBase {
			/**
			 * @type {number}
			 * @memberof ParticipantsDatum
			 */
			school_id: number;
			school_location: string;
			school_name: string;
		}
	
	}

	export interface TestParticipantsForRegion {
		participants_data: Api.TestParticipantsForRegion.ParticipantsDatum[];
		municipalities?: Api.TestParticipantsForRegion.Municipality[];
		total: Api.TestParticipantsBase[];
	}
	
	/**
	 * @export
	 * @namespace TestParticipantsForRegion
	 */
	export namespace TestParticipantsForRegion {
		export interface ParticipantsDatum extends Api.TestParticipantsBase {
			/**
			 * @type {number}
			 * @memberof ParticipantsDatum
			 */
			municipality_id: number;
			municipality_name: string;
		}
	
		export interface Municipality {
			/**
			 * @type {number}
			 * @memberof Municipality
			 */
			id: number;
			display_name: string;
		}
	
	}

	export interface TestProgressesAvg {
		/**
		 * @type {number}
		 * @memberof TestProgressesAvg
		 */
		avg_completion_percent: number;
		/**
		 * @type {number}
		 * @memberof TestProgressesAvg
		 */
		registered_students_count?: number;
		/**
		 * @type {number}
		 * @memberof TestProgressesAvg
		 */
		test_id: number;
		/**
		 * @type {number}
		 * @memberof TestProgressesAvg
		 */
		tested_students_count?: number;
	}

	export interface TestProgressesForMunicipality {
		avg_completion_percents: Api.TestProgressesForMunicipality.AvgCompletionPercent[];
		parallels_completion_percents: Api.TestProgressesForMunicipality.ParallelsCompletionPercent[];
		total: Api.TestProgressesTotal;
	}
	
	/**
	 * @export
	 * @namespace TestProgressesForMunicipality
	 */
	export namespace TestProgressesForMunicipality {
		export interface AvgCompletionPercent extends Api.TestProgressesAvg {
			/**
			 * @type {number}
			 * @memberof AvgCompletionPercent
			 */
			school_id: number;
			school_location: string;
			school_name: string;
		}
	
		export interface ParallelsCompletionPercent extends Api.TestProgressesParallels {
			/**
			 * @type {number}
			 * @memberof ParallelsCompletionPercent
			 */
			school_id: number;
		}
	
	}

	export interface TestProgressesForRegion {
		avg_completion_percents: (Api.TestProgressesForRegion.AvgCompletionPercent[]) | null;
		parallels_completion_percents: (Api.TestProgressesForRegion.ParallelsCompletionPercent[]) | null;
		total: Api.TestProgressesTotal;
	}
	
	/**
	 * @export
	 * @namespace TestProgressesForRegion
	 */
	export namespace TestProgressesForRegion {
		export interface AvgCompletionPercent extends Api.TestProgressesAvg {
			/**
			 * @type {number}
			 * @memberof AvgCompletionPercent
			 */
			municipality_id: number;
			municipality_name: string;
		}
	
		export interface ParallelsCompletionPercent extends Api.TestProgressesParallels {
			/**
			 * @type {number}
			 * @memberof ParallelsCompletionPercent
			 */
			municipality_id: number;
		}
	
	}

	export interface TestProgressesParallels {
		/**
		 * @type {number}
		 * @memberof TestProgressesParallels
		 */
		completion_percent: number;
		/**
		 * @type {number}
		 * @memberof TestProgressesParallels
		 */
		parallel: number;
		/**
		 * @type {number}
		 * @memberof TestProgressesParallels
		 */
		test_id: number;
	}

	export interface TestProgressesTotal {
		avg_completion_percents: Api.TestProgressesAvg[];
		parallels_completion_percents: Api.TestProgressesParallels[];
	}

}
